import React from 'react';
import HelpContent from './HelpContent';
import HidrogenoMaritimo from 'img/maritimo_hidrogeno.PNG';

const HidrogenoMaritimoHelp = () => (
  <HelpContent>
    <h1>Introducción de hidrógeno en transporte marítimo</h1>
    <p>
    Esta medida evalúa el impacto de la introducción de combustibles sostenibles en el transporte marítimo de carga a nivel nacional.
     Se implementa de forma analoga al SAF aéreo. La siguiente figura muestra un prototipo de buque comercial que funcionaría con hidrógeno,
      el cual se encuentra en desarrollo por las empresas Moss Maritime, Equinor, Wilhelmsen y DNV-GL.
    </p>
	<img src={HidrogenoMaritimo} alt="Hidrógeno en transporte marítimo" />
    <label>Figura: Hidrógeno en transporte marítimo. Fuente: Wilhelmsen https://www.wilhelmsen.com/</label>
    <p>
      <strong>Trayectoria 1:</strong> se implementa el uso de hidrogeno en un 0,8% para el año 2040 creciendo hasta el 30% en el año 2050.
    </p>
  </HelpContent>
);

export default HidrogenoMaritimoHelp;
